import { client } from '~publish/legacy/apollo-client'
import { graphql } from '~publish/graphql'
/**
 * Account-actor mutation that replaces the legacy `deleteHashtagGroup` RPC /
 * `POST /1/snippet_groups/delete.json` for Publish Hashtag Manager.
 * Backend ships as Snippet GraphQL (CHAN-12108), not HashtagGroup naming.
 */
export const DeleteSnippet = graphql(/* GraphQL */ `
  mutation DeleteSnippet($input: DeleteSnippetInput!) {
    deleteSnippet(input: $input) {
      __typename
      ... on DeleteSnippetSuccess {
        id
      }
      ... on VoidMutationError {
        message
      }
    }
  }
`)

export async function deleteHashtagGroupViaGraphQL(args: {
  organizationId: string
  snippetId: string
}): Promise<string> {
  const { data } = await client.mutate({
    mutation: DeleteSnippet,
    variables: {
      input: {
        organizationId: args.organizationId,
        id: args.snippetId,
      },
    },
  })

  const payload = data?.deleteSnippet
  if (!payload) {
    throw new Error('DeleteSnippet returned no payload')
  }
  if (payload.__typename === 'VoidMutationError') {
    throw new Error(payload.message)
  }
  if (payload.__typename !== 'DeleteSnippetSuccess') {
    throw new Error('DeleteSnippet returned an unexpected payload')
  }

  return payload.id
}
